// extracted by mini-css-extract-plugin
export default {"table":"Logs_table__b7n9j"};